<template>
  <div class="pay-info-page">
    <div class="pay-nav">
      <div class="pay-nav-left" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <div class="pay-nav-title">充值信息</div>
      <div class="pay-nav-right"></div>
    </div>

    <div class="pay-body">
      <div class="pay-hero">
        <div class="pay-amount">
          <span class="num">{{ payInfo.info && payInfo.info.amount }}</span>
          <span class="unit">元</span>
        </div>
        <div class="pay-countdown" v-if="showCountdown">
          请在 <em>{{ m >= 10 ? m : `0${m}` }}:{{ s >= 10 ? s : `0${s}` }}</em> 内完成支付
        </div>
        <div class="pay-tip" v-if="isOnlineAwaiting && validOnlinePayUrl">
          线上订单已创建，请先前往第三方支付页面完成支付，支付后返回本页等待回调。
          <span class="link" @click="openOnlinePay">立即前往支付</span>
        </div>
        <div class="pay-tip danger" v-else-if="isOnlineAwaiting && onlinePayUrlInvalid">支付地址无效，请联系客服重新获取链接。</div>
        <div class="pay-tip" v-else-if="isOnlinePayment && orderState === 2">线上支付已完成，余额已到账。</div>
        <div class="pay-tip danger" v-else-if="isOnlinePayment && orderState === 3">线上支付已取消或失败，请重新下单或联系客服。</div>
        <div class="pay-tip" v-else-if="isPaying">
          <template v-if="type === 'usdtpay'">
            请按金额转账到下方 USDT 地址，并上传支付截图。客服审核通过后到账。
          </template>
          <template v-else>
            请按金额扫码付款，并上传支付截图。客服审核通过后到账。
          </template>
          <span class="link" @click="$parent.openKefu">联系客服</span>
        </div>
        <div class="pay-tip" v-else-if="orderState === 1">凭证已提交，请耐心等待客服审核。</div>
        <div class="pay-tip" v-else-if="orderState === 2">审核已通过，余额已到账。</div>
        <div class="pay-tip danger" v-else-if="orderState === 3">审核未通过，如有疑问请联系客服。</div>
      </div>

      <div class="pay-card">
        <div class="row">
          <span class="label">订单号</span>
          <span class="value">
            {{ payInfo.deposit_no }}
            <em class="copy" @click="doCopy(payInfo.deposit_no)">复制</em>
          </span>
        </div>
        <div class="row">
          <span class="label">交易时间</span>
          <span class="value">{{ payInfo.info && payInfo.info.created_at }}</span>
        </div>
        <div class="row">
          <span class="label">充值方式</span>
          <span class="value">{{ payInfo.info && payInfo.info.paytype }}</span>
        </div>
        <div class="row">
          <span class="label">订单状态</span>
          <span class="value" :class="stateClass">{{ stateText }}</span>
        </div>
        <div class="row" v-if="isOnlinePayment">
          <span class="label">支付链接</span>
          <span class="value break">
            {{ validOnlinePayUrl ? '已获取' : (onlinePayUrl ? '地址无效' : '等待返回') }}
            <em class="copy" v-if="validOnlinePayUrl" @click="openOnlinePay">前往支付</em>
          </span>
        </div>
        <div class="row" v-if="isOnlinePayment && payExpireText">
          <span class="label">有效期</span>
          <span class="value">{{ payExpireText }}</span>
        </div>
        <div class="row" v-if="type == 'usdtpay'">
          <span class="label">收款地址</span>
          <span class="value break">
            {{ (payInfo.cardlist && (payInfo.cardlist.mch_id || payInfo.cardlist.wallet_address)) || '-' }}
            <em
              class="copy"
              v-if="payInfo.cardlist && (payInfo.cardlist.mch_id || payInfo.cardlist.wallet_address)"
              @click="doCopy(payInfo.cardlist.mch_id || payInfo.cardlist.wallet_address)"
            >复制</em>
          </span>
        </div>
        <div class="row" v-if="type == 'usdtpay' && payInfo.info && payInfo.info.real_money">
          <span class="label">应付USDT</span>
          <span class="value">{{ payInfo.info.real_money }}（汇率 {{ payInfo.info.usdtrate || '-' }}）</span>
        </div>

        <div class="qr-wrap" v-if="isPaying && payInfo.cardlist && payInfo.cardlist.payimg">
          <img :src="payInfo.cardlist.payimg" alt="收款码" />
          <p>{{ type === 'usdtpay' ? '可扫描上方二维码转账（请核对地址）' : '请使用对应 App 扫描上方收款码付款' }}</p>
        </div>
      </div>

      <div class="pay-online-card" v-if="isOnlinePayment">
        <div class="pay-online-title">线上支付</div>
        <div class="pay-online-desc">
          完成第三方支付后不要手动修改余额，返回本页等待回调即可。
        </div>
        <button type="button" class="pay-online-btn" :disabled="!validOnlinePayUrl" @click="openOnlinePay">
          {{ validOnlinePayUrl ? '前往第三方支付' : (onlinePayUrl ? '支付地址无效' : '支付链接加载中') }}
        </button>
      </div>

      <div class="proof-box" v-if="needProof && (isPaying || orderState === 1 || uploadedProof)">
        <div class="proof-title">上传支付凭证</div>
        <div class="proof-desc" v-if="canUpload">请上传付款成功截图，提交后等待后台审核上分</div>
        <div class="proof-preview" v-if="proofPreview || uploadedProof">
          <img :src="proofPreview || uploadedProof" alt="凭证预览" />
        </div>
        <div class="proof-actions" v-if="canUpload">
          <label class="proof-upload-btn">
            {{ proofPreview ? '重新选择图片' : '选择支付截图' }}
            <input type="file" accept="image/*" @change="onPickProof" hidden />
          </label>
          <button class="proof-submit-btn" :disabled="!proofFile || uploading" @click="submitProof">
            {{ uploading ? '提交中...' : '提交凭证等待审核' }}
          </button>
        </div>
        <div class="proof-done" v-else-if="orderState === 1">凭证已提交，等待客服审核</div>
        <div class="proof-done ok" v-else-if="orderState === 2">审核已通过</div>
        <div class="proof-done bad" v-else-if="orderState === 3">审核未通过</div>
      </div>
    </div>

    <div class="pay-footer">
      <button class="ft-btn" @click="$parent.goNav('/transRecord')">充值记录</button>
      <button class="ft-btn primary" @click="$parent.goNav('/mine')">返回个人中心</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: { info: {}, cardlist: {} },
      type: null,
      paymentMode: '',
      onlinePayUrl: '',
      onlineRedirected: false,
      pollTimer: null,
      pollCount: 0,
      pollLimit: 10,
      timer: null,
      m: 0,
      s: 0,
      proofFile: null,
      proofPreview: '',
      uploading: false,
      uploadedProof: '',
    };
  },
  computed: {
    orderState() {
      const info = this.payInfo.info || {};
      return info.state === undefined || info.state === null ? null : Number(info.state);
    },
    isPaying() {
      if (this.isOnlinePayment) {
        return this.orderState === null || this.orderState === 0 || this.orderState === 1;
      }
      return this.orderState === 0;
    },
    isOnlinePayment() {
      return this.paymentMode === 'online' || !!this.onlinePayUrl;
    },
    isOnlineAwaiting() {
      return this.isOnlinePayment && (this.orderState === null || this.orderState === 0 || this.orderState === 1);
    },
    validOnlinePayUrl() {
      return this.getValidExternalPayUrl(this.onlinePayUrl);
    },
    onlinePayUrlInvalid() {
      return this.isOnlinePayment && !!this.onlinePayUrl && !this.validOnlinePayUrl;
    },
    needProof() {
      return !this.isOnlinePayment && !!this.type;
    },
    showCountdown() {
      return this.isPaying || this.isOnlineAwaiting;
    },
    canUpload() {
      if (this.orderState === 0) return true;
      if (this.orderState === 1) {
        const has = this.uploadedProof || (this.payInfo.info && this.payInfo.info.pay_proof);
        return !has;
      }
      return false;
    },
    stateText() {
      if (this.isOnlinePayment) {
        if (this.orderState === 2) return '已完成';
        if (this.orderState === 3) return '已取消/失败';
        if (this.orderState === 1 || this.orderState === 0 || this.orderState === null) return '支付中';
      }
      const map = { 0: '待上传凭证', 1: '待审核', 2: '已完成', 3: '已拒绝' };
      return map[this.orderState] || '处理中';
    },
    stateClass() {
      if (this.isOnlinePayment) {
        if (this.orderState === 2) return 'ok';
        if (this.orderState === 3) return 'bad';
        return 'warn';
      }
      if (this.orderState === 2) return 'ok';
      if (this.orderState === 3) return 'bad';
      if (this.orderState === 1) return 'warn';
      return '';
    },
    payExpireText() {
      const info = this.payInfo.info || {};
      const expireAt = this.payInfo.pay_expire_at || info.pay_expire_at || info.expire_at;
      return expireAt || '';
    },
  },
  created() {
    this.initPaymentContext();
    const deposit_no = this.$route.query.deposit_no;
    if (deposit_no) this.getpayinfo(deposit_no);
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
    if (this.pollTimer) clearTimeout(this.pollTimer);
  },
  methods: {
    initPaymentContext() {
      const query = this.$route.query || {};
      this.paymentMode = String(query.payment_mode || '').toLowerCase();
      this.onlinePayUrl = query.pay_url ? decodeURIComponent(query.pay_url) : '';
      try {
        const cacheRaw = typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage.getItem('cs_pending_online_payment') : '';
        if (cacheRaw) {
          const cache = JSON.parse(cacheRaw);
          if (cache && cache.deposit_no === query.deposit_no) {
            this.paymentMode = this.paymentMode || String(cache.payment_mode || '').toLowerCase();
            this.onlinePayUrl = this.onlinePayUrl || cache.pay_url || '';
          }
        }
      } catch (err) {
        // ignore storage parse issues
      }
    },
    syncOnlinePaymentContext(resData) {
      const data = resData || {};
      const info = data.info || {};
      const payUrl = data.pay_url || data.payUrl || data.redirect_url || data.url || info.pay_url || info.payUrl || info.redirect_url || info.url || '';
      if (payUrl) {
        this.onlinePayUrl = payUrl;
      }
      const mode = String(data.payment_mode || data.paymentMode || info.payment_mode || info.paymentMode || this.$route.query.payment_mode || '').toLowerCase();
      if (mode === 'online') {
        this.paymentMode = 'online';
      }
    },
    shouldAutoRedirectOnline() {
      return this.isOnlinePayment && !!this.validOnlinePayUrl && !this.onlineRedirected && this.orderState !== 2 && this.orderState !== 3;
    },
    openOnlinePay() {
      const targetUrl = this.validOnlinePayUrl;
      if (!targetUrl) {
        this.$parent.showTost(0, this.onlinePayUrl ? '支付地址无效' : '支付链接暂未返回');
        return;
      }
      this.onlineRedirected = true;
      try {
        if (typeof window !== 'undefined' && window.sessionStorage) {
          const query = this.$route.query || {};
          const key = `cs_online_payment_redirected_${query.deposit_no || 'unknown'}`;
          window.sessionStorage.setItem(key, '1');
        }
      } catch (err) {
        // ignore
      }
      window.location.href = targetUrl;
    },
    startOnlinePolling(deposit_no) {
      if (!this.isOnlinePayment || !deposit_no || this.orderState === 2 || this.orderState === 3) return;
      if (this.pollTimer) return;
      this.pollCount = 0;
      const loop = () => {
        if (!this.isOnlinePayment || this.orderState === 2 || this.orderState === 3) {
          if (this.pollTimer) clearTimeout(this.pollTimer);
          this.pollTimer = null;
          return;
        }
        this.pollCount += 1;
        if (this.pollCount > this.pollLimit) {
          if (this.pollTimer) clearTimeout(this.pollTimer);
          this.pollTimer = null;
          return;
        }
        this.refreshPayInfo(deposit_no, true).catch(() => {}).finally(() => {
          if (!this.isOnlinePayment || this.orderState === 2 || this.orderState === 3) {
            if (this.pollTimer) clearTimeout(this.pollTimer);
            this.pollTimer = null;
            return;
          }
          this.pollTimer = setTimeout(loop, 5000);
        });
      };
      this.pollTimer = setTimeout(loop, 5000);
    },
    refreshPayInfo(deposit_no, silent = false) {
      const that = this;
      if (!silent) that.$parent.showLoading();
      return that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        if (res.code === 200) {
          that.payInfo = res.data || { info: {}, cardlist: {} };
          that.payInfo.deposit_no = that.payInfo.deposit_no || deposit_no;
          that.type = res.message;
          that.syncOnlinePaymentContext(res.data || {});
          if (res.data && res.data.info && res.data.info.pay_proof_url) {
            that.uploadedProof = res.data.info.pay_proof_url;
          }
          if (that.isPaying) that.countTime();
          if (!that.isOnlinePayment && that.pollTimer) {
            clearTimeout(that.pollTimer);
            that.pollTimer = null;
          }
        } else if (!silent) {
          that.$parent.showTost(0, res.message);
        }
        return res;
      }).finally(() => {
        if (!silent) that.$parent.hideLoading();
      });
    },
    doCopy(msg) {
      if (!msg) return;
      const cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.$parent.showTost(1, '复制成功！');
    },
    getpayinfo(deposit_no) {
      const that = this;
      this.$parent.showLoading();
      that.refreshPayInfo(deposit_no).then(() => {
        if (that.isOnlinePayment && that.orderState !== 2 && that.orderState !== 3) {
          that.startOnlinePolling(deposit_no);
        }
        if (that.shouldAutoRedirectOnline()) {
          const targetUrl = that.validOnlinePayUrl;
          if (!targetUrl) {
            if (that.onlinePayUrl) {
              that.$parent.showTost(0, '支付地址无效，请联系客服重新获取链接');
            }
            return;
          }
          const redirectKey = `cs_online_payment_redirected_${deposit_no}`;
          try {
            if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem(redirectKey) !== '1') {
              window.sessionStorage.setItem(redirectKey, '1');
              that.onlineRedirected = true;
              setTimeout(() => {
                window.location.href = targetUrl;
              }, 200);
            }
          } catch (err) {
            that.onlineRedirected = true;
            setTimeout(() => {
              window.location.href = targetUrl;
            }, 200);
          }
        }
      }).finally(() => {
        that.$parent.hideLoading();
      });
    },
    getValidExternalPayUrl(rawUrl) {
      const value = String(rawUrl || '').trim();
      if (!value) return '';
      try {
        const URLCtor = typeof window !== 'undefined' && window.URL ? window.URL : URL;
        const parsed = new URLCtor(value);
        if (!parsed.host) return '';
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
        return parsed.href;
      } catch (err) {
        return '';
      }
    },
    onPickProof(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type)) {
        this.$parent.showTost(0, '请上传图片文件');
        return;
      }
      const that = this;
      that.compressImage(file)
        .then(compressed => {
          that.proofFile = compressed;
          if (that.proofPreview) URL.revokeObjectURL(that.proofPreview);
          that.proofPreview = URL.createObjectURL(compressed);
        })
        .catch(() => {
          that.proofFile = file;
          if (that.proofPreview) URL.revokeObjectURL(that.proofPreview);
          that.proofPreview = URL.createObjectURL(file);
        });
    },
    compressImage(file, maxSide = 1600, quality = 0.72) {
      return new Promise((resolve, reject) => {
        if (!file || !/^image\//.test(file.type)) {
          reject(new Error('invalid'));
          return;
        }
        // 小于 800KB 不压缩，直接上传
        if (file.size < 800 * 1024) {
          resolve(file);
          return;
        }
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('read fail'));
        reader.onload = () => {
          const img = new Image();
          img.onerror = () => reject(new Error('img fail'));
          img.onload = () => {
            let w = img.width;
            let h = img.height;
            if (w > maxSide || h > maxSide) {
              if (w >= h) {
                h = Math.round((h * maxSide) / w);
                w = maxSide;
              } else {
                w = Math.round((w * maxSide) / h);
                h = maxSide;
              }
            }
            const canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, w, h);
            canvas.toBlob(
              blob => {
                if (!blob) {
                  reject(new Error('compress fail'));
                  return;
                }
                const name = (file.name || 'proof.jpg').replace(/\.\w+$/, '.jpg');
                resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
              },
              'image/jpeg',
              quality
            );
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    },
    submitProof() {
      const that = this;
      if (!that.proofFile) {
        that.$parent.showTost(0, '请先选择支付截图');
        return;
      }
      const deposit_no = that.payInfo.deposit_no || (that.$route.query && that.$route.query.deposit_no);
      if (!deposit_no) {
        that.$parent.showTost(0, '订单号丢失');
        return;
      }
      that.uploading = true;
      that.$parent.showLoading();
      const formData = new FormData();
      formData.append('file', that.proofFile);
      formData.append('deposit_no', deposit_no);
      that.$apiFun
        .post('/api/uploadPayProof', formData, { timeout: 60000 })
        .then(res => {
          that.uploading = false;
          that.$parent.hideLoading();
          if (res.code != 200) {
            that.$parent.showTost(0, res.message || '提交失败');
            return;
          }
          that.$parent.showTost(1, res.message || '凭证已提交，等待审核');
          that.uploadedProof = (res.data && res.data.pay_proof) || that.proofPreview;
          that.proofFile = null;
          if (that.payInfo.info) {
            that.payInfo.info.state = 1;
            that.payInfo.info.pay_proof_url = that.uploadedProof;
          }
        })
        .catch(err => {
          that.uploading = false;
          that.$parent.hideLoading();
          const isTimeout = err && (err.code === 'ECONNABORTED' || /timeout/i.test(String(err.message || '')));
          that.$parent.showTost(0, isTimeout ? '上传超时，请压缩后再试或换更小图片' : '上传失败，请重试');
        });
    },
    countTime() {
      const that = this;
      if (!that.isPaying || !that.payInfo.info || (!that.payInfo.info.created_at && !that.payInfo.info.pay_expire_at && !that.payInfo.pay_expire_at)) return;
      const now = Date.now();
      const expireSource = that.payInfo.pay_expire_at || that.payInfo.info.pay_expire_at || that.payInfo.info.expire_at;
      const createdTime = expireSource
        ? new Date(String(expireSource).replace(/-/g, '/')).getTime() - (60 * 60 * 1000)
        : new Date(String(that.payInfo.info.created_at).replace(/-/g, '/')).getTime();
      const leftTime = expireSource ? new Date(String(expireSource).replace(/-/g, '/')).getTime() - now : createdTime + 1000 * 60 * 60 - now;
      if (leftTime >= 0) {
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
        that.timer = setTimeout(that.countTime, 1000);
      } else {
        that.m = 0;
        that.s = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-info-page {
  min-height: 100vh;
  background: #fff;
  color: #2d241d;
  padding-bottom: 76px;
  box-sizing: border-box;
}

.pay-nav {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 8px;
  background: linear-gradient(135deg, #603514 0%, #965723 58%, #bd7a38 100%);
  border-bottom: 1px solid rgba(246, 223, 169, 0.52);
  box-shadow: 0 5px 16px rgba(96, 53, 20, 0.22);
}
.pay-nav-left,
.pay-nav-right {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-nav-left .van-icon {
  font-size: 20px;
  color: #fff;
}
.pay-nav-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.04em;
}

.pay-body {
  padding: 14px 14px 20px;
}

.pay-hero {
  background: linear-gradient(140deg, #fffdf8 0%, #f7e7bd 100%);
  border-radius: 16px;
  padding: 18px 16px 14px;
  margin-bottom: 12px;
  border: 1px solid #d9aa54;
  box-shadow: 0 8px 22px rgba(169, 103, 38, 0.12);
}
.pay-amount {
  text-align: center;
  .num {
    font-size: 34px;
    font-weight: 700;
    color: #a86128;
  }
  .unit {
    margin-left: 4px;
    font-size: 14px;
    color: #8c7c6f;
  }
}
.pay-countdown {
  margin-top: 8px;
  text-align: center;
  color: #74675d;
  font-size: 13px;
  em {
    color: #d94c4c;
    font-style: normal;
    font-weight: 600;
  }
}
.pay-tip {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: #8c7c6f;
  line-height: 1.6;
  &.danger {
    color: #d94c4c;
  }
  .link {
    color: #a86128;
    margin-left: 4px;
    font-weight: 600;
  }
}

.pay-card,
.pay-online-card,
.proof-box {
  background: #fff;
  border-radius: 16px;
  padding: 6px 14px 14px;
  margin-bottom: 12px;
  border: 1px solid #eadfd2;
  box-shadow: 0 7px 18px rgba(104, 69, 36, 0.08);
}

.pay-online-card {
  padding: 16px;
}

.pay-online-title,
.proof-title {
  font-size: 15px;
  font-weight: 700;
  color: #2d241d;
  margin-bottom: 6px;
}

.pay-online-desc,
.proof-desc {
  font-size: 12px;
  color: #8c7c6f;
  margin-bottom: 12px;
  line-height: 1.5;
}

.pay-online-btn {
  width: 100%;
  height: 42px;
  border: none;
  border-radius: 22px;
  background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
  color: #4c2a10;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(169, 103, 38, 0.22);
}
.pay-online-btn:disabled {
  opacity: 0.5;
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f0e8de;
  font-size: 13px;
  &:last-of-type {
    border-bottom: none;
  }
  .label {
    color: #95877b;
    flex-shrink: 0;
  }
  .value {
    color: #332820;
    text-align: right;
    word-break: break-all;
    &.break {
      max-width: 70%;
    }
    &.ok {
      color: #1f7a5c;
    }
    &.bad {
      color: #d94c4c;
    }
    &.warn {
      color: #a86128;
    }
  }
  .copy {
    color: #a86128;
    font-style: normal;
    margin-left: 8px;
    font-weight: 600;
  }
}
.qr-wrap {
  padding-top: 8px;
  text-align: center;
  img {
    width: 72%;
    max-width: 260px;
    display: block;
    margin: 0 auto;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #eadfd2;
    box-shadow: 0 4px 12px rgba(104, 69, 36, 0.08);
  }
  p {
    margin-top: 8px;
    font-size: 12px;
    color: #8c7c6f;
  }
}

.proof-box {
  padding: 16px;
}
.proof-preview img {
  width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 10px;
  background: #fbf7f1;
  border: 1px solid #eadfd2;
  margin-bottom: 12px;
}
.proof-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.proof-upload-btn,
.proof-submit-btn {
  display: block;
  text-align: center;
  padding: 12px;
  border-radius: 24px;
  font-size: 14px;
}
.proof-upload-btn {
  background: #fcfaf7;
  color: #6a4225;
  border: 1px solid #eadfd2;
}
.proof-submit-btn {
  background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
  color: #4c2a10;
  font-weight: 700;
  border: none;
  box-shadow: 0 8px 20px rgba(169, 103, 38, 0.22);
}
.proof-submit-btn:disabled {
  opacity: 0.5;
  box-shadow: none;
}
.proof-done {
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  color: #a86128;
  &.ok {
    color: #1f7a5c;
  }
  &.bad {
    color: #d94c4c;
  }
}

.pay-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  gap: 10px;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #eadfd2;
  box-shadow: 0 -4px 16px rgba(104, 69, 36, 0.06);
  z-index: 30;
}
.ft-btn {
  flex: 1;
  height: 42px;
  border-radius: 22px;
  border: 1px solid #eadfd2;
  background: #fcfaf7;
  color: #6a4225;
  font-size: 14px;
  &.primary {
    border: none;
    background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
    color: #4c2a10;
    font-weight: 700;
    box-shadow: 0 8px 20px rgba(169, 103, 38, 0.22);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue